import React, { Dispatch, FC, useState } from 'react';
import classes from './configDialog.module.scss';
import { ReactComponent as Pen } from '../../assets/images/userPen.svg';
import { ReactComponent as Delete } from '../../assets/images/delete.svg';
import { ChangeDeleteDialog } from '../Dialogs/ChangeDeleteDialog';
import { ChangeUpdateDialog } from '../Dialogs/ChangeUpdateDialog';
import { Thank } from '../../types/thank';
import Stub from '../../assets/images/stubAvatar.svg';
import { getNoun } from '../../utils/getNoun';

type ThanksItemProps = {
  item: Thank;
  onChangeDelete: Dispatch<number>;
  onChangeUpdate: (id: number, description: string) => Promise<void>;
};

export const ThanksItemReceived: FC<ThanksItemProps> = ({
  item,
  onChangeDelete,
  onChangeUpdate,
}) => {
  const [deleteWindow, setDeleteWindow] = useState<boolean>(false);
  const [updateWindow, setUpdateWindow] = useState<boolean>(false);
  const onChangeUpdateWindow = (description: string) => {
    onChangeUpdate(item.id, description).then(() => {
      setUpdateWindow(false);
    });
  };

  const date = item.dateAt;
  const nowDate = new Date();
  const currentDate = Date.parse(nowDate.toString());
  const days = (currentDate - Date.parse(date)) / 86400000;

  return (
    <div className={classes.wrapperItem}>
      <div style={{ paddingBottom: '15px' }} className={classes.wrapper}>
        <p className={classes.day}>
          {Math.round(days) === 0
            ? `сегодня`
            : `${Math.round(days)} ${getNoun(
                Math.round(days),
                'день',
                'дня',
                'дней',
              )} назад`}
        </p>
        <div className={classes.wrapper}>
          <Pen onClick={() => setUpdateWindow(true)} />
          <ChangeUpdateDialog
            value={item.description}
            onChangeUpdate={onChangeUpdateWindow}
            open={updateWindow}
            setOpen={setUpdateWindow}
          />
          <Delete onClick={() => setDeleteWindow(true)} />
          <ChangeDeleteDialog
            button="Удалить"
            title="Удаление Спасибо"
            open={deleteWindow}
            onChangeDelete={() => onChangeDelete(item.id)}
            setOpen={setDeleteWindow}
          />
        </div>
      </div>
      <div className={classes.wrapperThanks}>
        <div>
          <div className={classes.wrapperBody}>
            <div className={classes.profileImage}>
              {item.fromStaff.avatar ? (
                <img
                  className={classes.image}
                  src={`https://radar-app.tmk-group.com/${item.fromStaff.avatar}`}
                  alt={`${item.fromStaff.lastname}`}
                />
              ) : (
                <img
                  className={classes.image}
                  src={`${Stub}`}
                  alt={`${item.fromStaff.lastname}`}
                />
              )}
              <img
                src={`https://radar-app.tmk-group.com/${item.value.icon}`}
                alt={`${item.value.name}`}
              />
            </div>
            <div className={classes.infoUser}>
              <div>
                <p className={classes.nameUser}>
                  {item.fromStaff.lastname} {item.fromStaff.firstname}
                </p>
                <p className={classes.lastNameUser}>
                  {item.fromStaff.org.orgShortName},{' '}
                  {item.fromStaff.subDivision.subDivisionName}
                </p>
              </div>
              <p className={classes.qualityMark}>
                Получен знак «{item.value.name}»
              </p>
            </div>
          </div>
          <p className={classes.description}>
            {item.value.valueTypes?.length
              ? `${item.value.valueTypes.map((e) => `${e.description}`)}`
              : ''}
          </p>
          <p className={classes.descriptionTwo}>— {item.description}</p>
        </div>
      </div>
    </div>
  );
};
